import { useFilters } from './FilterContext';
import { X } from 'lucide-react';
import { useState, useMemo } from 'react';

export function FilterBar({ data = [] }) {
  const { filters, updateFilter, clearFilters } = useFilters();

  const availableVillages = useMemo(() => {
    if (!data.length) return [];
    return [...new Set(data.map(d => d.farmers?.village).filter(Boolean))].sort();
  }, [data]);

  const availableCrops = useMemo(() => {
    if (!data.length) return [];
    return [...new Set(data.map(d => d.previous_crop).filter(Boolean))].sort();
  }, [data]);

  const hasActiveFilters = Object.values(filters).some(arr => arr.length > 0);

  return (
    <div className="bg-gray-50 border-b border-gray-200 px-6 py-4">
      <div className="flex items-center gap-4 flex-wrap">
        <span className="text-sm font-medium text-gray-700">Filters:</span>

        <MultiSelectFilter
          label="Village"
          options={availableVillages}
          selected={filters.villages}
          onChange={(values) => updateFilter('villages', values)}
        />

        <MultiSelectFilter
          label="Previous Crop"
          options={availableCrops}
          selected={filters.previousCrop}
          onChange={(values) => updateFilter('previousCrop', values)}
        />

        <MultiSelectFilter
          label="Farm Size"
          options={['< 1 acre', '1-2 acres', '> 2 acres']}
          selected={filters.farmSize}
          onChange={(values) => updateFilter('farmSize', values)}
        />

        {hasActiveFilters && (
          <button
            onClick={clearFilters}
            className="ml-auto flex items-center gap-1 px-3 py-1.5 text-sm text-gray-600 hover:text-gray-900 hover:bg-white rounded-md transition-colors"
          >
            <X className="w-4 h-4" />
            Clear all
          </button>
        )}
      </div>
    </div>
  );
}

function MultiSelectFilter({ label, options, selected = [], onChange }) {
  const [isOpen, setIsOpen] = useState(false);

  const toggleOption = (option) => {
    if (selected.includes(option)) {
      onChange(selected.filter(v => v !== option));
    } else {
      onChange([...selected, option]);
    }
  };

  return (
    <div className="relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className={`px-3 py-1.5 text-sm rounded-full border transition-colors ${
          selected.length > 0
            ? 'bg-[#2E7D32] text-white border-[#2E7D32]'
            : 'bg-white text-gray-700 border-gray-300 hover:border-gray-400'
        }`}
      >
        {label}
        {selected.length > 0 && ` (${selected.length})`}
      </button>

      {isOpen && options.length > 0 && (
        <>
          <div className="fixed inset-0 z-10" onClick={() => setIsOpen(false)} />
          <div className="absolute top-full left-0 mt-1 bg-white border border-gray-200 rounded-lg shadow-lg z-20 min-w-[200px] max-h-[300px] overflow-y-auto">
            {options.map((option) => (
              <label
                key={option}
                className="flex items-center gap-2 px-3 py-2 hover:bg-gray-50 cursor-pointer"
              >
                <input
                  type="checkbox"
                  checked={selected.includes(option)}
                  onChange={() => toggleOption(option)}
                  className="rounded border-gray-300 text-[#2E7D32] focus:ring-[#2E7D32]"
                />
                <span className="text-sm text-gray-700">{option}</span>
              </label>
            ))}
          </div>
        </>
      )}
    </div>
  );
}